export default "__VITE_ASSET__usgRG4mG__"